import moment from "moment-timezone";

export function changeUTCTime(timestamp, TimeZone) {
  
    var cnvrtedTimeStmp = moment(timestamp).tz(TimeZone)
    return cnvrtedTimeStmp;
}
